import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const RefundPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Refund Policy</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Eligibility for Refund">
          <p>Refunds are applicable on items that are damaged, defective, or incorrect upon delivery. Requests must be raised within 7 days of delivery.</p>
        </Section>
        <Section title="2. Non-Refundable Items">
          <p>Items that have been used, washed, or altered are not eligible for refund. Sale or discounted items are non-refundable unless defective.</p>
        </Section>
        <Section title="3. Refund Process">
          <p>Once your return is received and inspected, we will notify you via email. Approved refunds are processed within 5–7 business days to your original payment method.</p>
        </Section>
        <Section title="4. Refund for COD Orders">
          <p>For Cash on Delivery orders, refunds will be processed as bank transfers. You will need to provide your bank account details.</p>
        </Section>
        <Section title="5. Contact Us">
          <p>To initiate a refund, email us at <span className="text-[#DAA520]">sastadealpvt@gmail.com</span> with your order number and reason.</p>
        </Section>
      </div>
    </div>
  </div>
);

export default RefundPolicyPage;
